import { useEffect } from "react"
import type { PopoverPropsType } from "."
import { registerPopover } from "./popoverRegistry"
import { useDesktopPopoverCore } from "./useDesktopPopoverCore"

export const DesktopPopover = ({
  targetRef,
  children,
  isOpen,
  onOpenChange,
  ...rest
}: PopoverPropsType) => {
  const referenceElement =
    targetRef && "current" in targetRef ? targetRef.current : targetRef

  useEffect(() => {
    if (!onOpenChange) return

    return registerPopover(() => {
      onOpenChange(false)
    })
  }, [onOpenChange])

  const { refs, getReferenceProps, renderFloating } = useDesktopPopoverCore({
    isOpen,
    onOpenChange,
    referenceElement,
    ...rest,
  })

  if (typeof children === "function") {
    return children({ refs, getReferenceProps, renderFloating })
  }

  return renderFloating(children)
}
